import { routePathPrefix } from './Router.functions';

export const BASE_PATH = import.meta.env.VITE_BASE_PATH || '/';

export const RouterPaths = {
  signIn: routePathPrefix('auth/sign-in'),
  signUp: routePathPrefix('auth/sign-up'),
  activate: routePathPrefix('auth/activate'),
  createWorkspace: routePathPrefix('auth/create-workspace'),
  accountRecovery: routePathPrefix('auth/account-recovery'),
  dashboard: routePathPrefix('dashboard'),
  funnels: routePathPrefix('workspace/funnel'),
  // Alias for the funnel ("pipe") page — the Pipe page (with ProfilingOverlay)
  // is mounted at the funnels route. RET-1386 redirects here on onboarding
  // completion so the "leads entering funnel" animation plays. Shared contract
  // with RET-1387 (profiling animation).
  pipe: routePathPrefix('workspace/funnel'),
  chat: routePathPrefix('workspace/chat'),
  agenda: routePathPrefix('agenda'),
  directory: routePathPrefix('workspace/directory'),
  leadbot: routePathPrefix('leadbot'),
  // AGI-284 — the destination the bell opens. English like every other path
  // (the page TITLE is "Centro de avisos"; routes are not copy). Named after
  // the Alert Center on purpose: when its MVP (RET-1874) ships a destination
  // of its own, it inherits this path instead of breaking saved links.
  alertCenter: routePathPrefix('alert-center'),
  smartLeadbotConfig: routePathPrefix('leadbot/smart-config'),
  leadclick: routePathPrefix('widget'),
  analytics: routePathPrefix('workspace/analytics'),
  assistant: routePathPrefix('workspace/assistant'),
  wapi: routePathPrefix('whatsapp-business-api'),
  tiktok: routePathPrefix('tiktok'),
  help: routePathPrefix('help'),
  settings: routePathPrefix('settings'),
  onboarding: routePathPrefix('onboarding'),
  paymentSuccess: routePathPrefix('payment-success'),
  recorder: routePathPrefix('recorder'),
};

export const TermsAndConditionsURL =
  'https://leadsales.io/terminos-y-condiciones';

export const PublicRoutes = [
  RouterPaths.signIn,
  RouterPaths.activate,
  RouterPaths.signUp,
  RouterPaths.accountRecovery,
];
